import { render, staticRenderFns } from "./Preface.vue?vue&type=template&id=a5c5b8d8&scoped=true&"
import script from "./Preface.vue?vue&type=script&lang=js&"
export * from "./Preface.vue?vue&type=script&lang=js&"
import style0 from "./Preface.vue?vue&type=style&index=0&id=a5c5b8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c5b8d8",
  null
  
)

export default component.exports